var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 7.24245 21.2313 3.1317 17.2174 1.1907V22.8092C21.2313 20.8683 24 16.7575 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 16.7575 2.76867 20.8683 6.78263 22.8093V1.1907C2.76867 3.1317 0 7.24245 0 12Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86955 12C8.86955 13.7289 10.2711 15.1304 12 15.1304C13.7289 15.1304 15.1305 13.7289 15.1305 12V10.9565H8.86955V12Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 9.91302H13.0434C13.0434 9.33674 12.5762 8.86954 12 8.86954C11.4237 8.86954 10.9565 9.33674 10.9565 9.91302H7.82602C7.82602 10.4893 8.328 10.9565 8.90424 10.9565H8.8695C8.8695 11.5328 9.33666 12 9.91299 12C9.91299 12.5763 10.3801 13.0435 10.9565 13.0435H13.0434C13.6198 13.0435 14.0869 12.5763 14.0869 12C14.6633 12 15.1304 11.5328 15.1304 10.9565H15.0956C15.672 10.9565 16.1739 10.4893 16.1739 9.91302Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.4fc0ca4dc06117dd74e781c80db16277.svg";
export { ForwardRef as ReactComponent };